import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Spin, Input, Button, Divider } from "antd";
import ShopifyLogo from "../../../../public/Icons/shopify.svg";
import { useShopifySyncOrder, useShopifyInstallLink } from "../../../../hooks/integrations/shopify";
import StoreIndexTable from "./StoreIndexTable";
import { get } from "lodash-es";
import { useParams } from "react-router";
import { useOrganizationContext } from "contextProviders/organization/OrganizationProvider";

const OrganizationStorePage = () => {
  const [shopifyDomain, setShopifyDomain] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const { syncOrderDetails } = useShopifySyncOrder();
  const { installLink, generateInstallLink } = useShopifyInstallLink();
  const disabled = syncOrderDetails.loading || formSubmitted;
  const params = useParams();
  const organizationID = get(params, "organization_id");
  const organizationDetails = useOrganizationContext();

  const redirectToInstallLink = () => {
    if (installLink.error) setFormSubmitted(false);
    if (installLink.data && installLink.data.url) {
      window.location.href = installLink.data.url;
    }
  };

  useEffect(redirectToInstallLink, [installLink]);

  const onChange = (e) => setShopifyDomain(e.target.value);
  const onClick = (e, shopifyDomain) => {
    e.preventDefault();
    const localStorage = window.localStorage;
    localStorage.setItem("install_store_organizationID", organizationID);
    setFormSubmitted(true);
    generateInstallLink(shopifyDomain.trim().replace(/\/+$/, ""));
  };

  return (
    <Spin spinning={syncOrderDetails.loading || organizationDetails.loading}>
      <div id="organization-store-page" className="page-container">
        <h2 className="organization-store-page-header">{get(organizationDetails, "data.name")}</h2>
        <div className="page-wrapper">
          <div className="shopify-logo-wrapper">
            <img alt="Shopify Logo" className="shopify-logo" src={ShopifyLogo} />
          </div>

          <div className="header-wrapper">
            <h3 className="header">Link Your Shopify Store</h3>
          </div>

          <div className="input-wrapper">
            <Input
              className="shopify-domain-input"
              disabled={disabled}
              onChange={onChange}
              placeholder="Enter Shopify Domain"
              value={shopifyDomain}
            />
            <p className="help-text">You will be redirected to Shopify on submission</p>
          </div>

          <div className="button-wrapper">
            <Button
              className="submit-button"
              disabled={disabled || !shopifyDomain}
              onClick={(e) => onClick(e, shopifyDomain)}
            >
              Submit
            </Button>
          </div>

          <Divider />

          <div className="stores-table-wrapper">
            <StoreIndexTable organizationID={organizationID} />
          </div>
        </div>
      </div>
    </Spin>
  );
};

OrganizationStorePage.propTypes = {
  match: PropTypes.object,
};

export default OrganizationStorePage;
